import React from 'react';
import { FiCheckCircle, FiClock, FiEye, FiArrowLeft } from 'react-icons/fi';

const FormSubmissionComplete = ({ 
	form, 
	submissionData, 
	onReturnToForms, 
	onViewSubmissions,
	isUpdate = false 
}) => {
	// Success messaging based on whether it's an update
	const getSuccessMessage = () => {
		if (isUpdate) {
			return {
				title: "Form Updated Successfully!",
				subtitle: `Your ${form?.name} submission has been updated.`,
				description: "Your changes have been saved and our team has been notified. You'll receive updates via email as we review your updated submission."
			};
		} else {
			return {
				title: "Form Submitted Successfully!",
				subtitle: `Your ${form?.name} submission has been received.`,
				description: "Our team has been notified and will begin processing your request. You'll receive updates via email as we work on your submission."
			};
		}
	};

	const successInfo = getSuccessMessage();


	return (
		<div className='min-h-screen bg-gray-50 p-4 sm:p-6 lg:p-8'>
			<div className='max-w-3xl mx-auto'>
				{/* Success Header */}
				<div className='bg-white rounded-lg shadow-sm border mb-8'>
					<div className='p-8 text-center'>
						{/* Success Icon */}
						<div className='mx-auto flex items-center justify-center w-16 h-16 rounded-full bg-green-100 mb-6'>
							<FiCheckCircle className='w-8 h-8 text-green-600' />
						</div>

						{/* Success Message */}
						<h1 className='text-2xl font-glacial font-bold text-gray-900 mb-2'>
							{successInfo.title}
						</h1>
						<p className='text-lg font-montserrat-medium text-gray-700 mb-4'>
							{successInfo.subtitle}
						</p>
						<p className='text-base font-montserrat-regular text-gray-600 max-w-xl mx-auto leading-relaxed'>
							{successInfo.description}
						</p>
					</div>
				</div>

				{/* Form Details */}
				<div className='bg-white rounded-lg shadow-sm border mb-8'>
					<div className='p-6'>
						<h2 className='text-lg font-montserrat-medium text-gray-900 mb-4'>
							Submission Details
						</h2>
						<div className='space-y-3'>
							<div className='flex justify-between items-center py-2 border-b border-gray-100'>
								<span className='text-sm font-montserrat-medium text-gray-600'>Form Name:</span>
								<span className='text-sm font-montserrat-regular text-gray-900'>{form?.name}</span>
							</div>
							<div className='flex justify-between items-center py-2 border-b border-gray-100'>
								<span className='text-sm font-montserrat-medium text-gray-600'>Submission Time:</span>
								<span className='text-sm font-montserrat-regular text-gray-900'>
									{new Date().toLocaleString()}
								</span>
							</div>
							<div className='flex justify-between items-center py-2'>
								<span className='text-sm font-montserrat-medium text-gray-600'>Status:</span>
								<span className='inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-montserrat-medium bg-blue-100 text-blue-800'>
									Submitted
								</span>
							</div>
						</div>
					</div>
				</div>


				{/* Action Buttons */}
				<div className='flex flex-col sm:flex-row gap-4 justify-center'>
					<button
						onClick={onReturnToForms}
						className='inline-flex items-center justify-center px-6 py-3 border border-gray-300 shadow-sm text-sm font-montserrat-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900 transition-colors'>
						<FiArrowLeft className='mr-2 h-4 w-4' />
						Return to Forms
					</button>
					
					{onViewSubmissions && (
						<button
							onClick={onViewSubmissions}
							className='inline-flex items-center justify-center px-6 py-3 border border-transparent shadow-sm text-sm font-montserrat-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900 transition-colors'>
							<FiEye className='mr-2 h-4 w-4' />
							View All Submissions
						</button>
					)}
				</div>

				{/* Additional Information */}
				<div className='mt-8 text-center'>
					<p className='text-xs font-montserrat-regular text-gray-500'>
						Questions about your submission? Contact our support team at{' '}
						<a 
							href='mailto:hello@janerothe.io' 
							className='text-primary hover:text-gray-800 transition-colors'
						>
							hello@janerothe.io
						</a>
					</p>
				</div>
			</div>
		</div>
	);
};

export default FormSubmissionComplete;